import React, { Component } from 'react';
import { matomoTrackCustomEvent } from './../../../../MatomoTracking'
export class ReferrerImplementation extends Component {
    displayName = ReferrerImplementation.name;

    constructor(props) {
        super(props);
        this.state = {
            active: this.props.active,
            // The shareable configuration link, fetched on demand rather
            // than on mount so opening the tab does not store a
            // configuration nobody asked to share.
            sharingLink: '',
            sharingState: '',
            sharingLines: null
        };
    }

    // Stores the current property selection and returns the link that
    // reloads it. Sharing carries the properties only, never the Resource
    // Key, so a shared link cannot spend the sharer's allowance.
    createSharingLink = (e) => {
        e.preventDefault();
        if (this.state.sharingState === 'loading') {
            return;
        }
        this.setState({ sharingState: 'loading' });

        fetch('api/configuration/addconfig', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(this.props.selectedProperties || [])
        })
            .then((response) => {
                if (response.ok === false) {
                    throw new Error('addconfig failed');
                }
                return response.text();
            })
            .then((data) => {
                this.setState({
                    sharingLink: window.location.protocol + '//' +
                        window.location.host + '/' + data,
                    sharingState: 'ready'
                });
                matomoTrackCustomEvent('Configuration Shared: ', data);
                // The social copy is only needed once a link exists.
                return fetch('api/data/sociallines')
                    .then((response) => response.json())
                    .then((lines) => this.setState({ sharingLines: lines }))
                    .catch(() => { });
            })
            .catch(() => this.setState({ sharingState: 'failed' }));
    };

    copySharingLink = (e) => {
        e.preventDefault();
        this.copy(this.state.sharingLink);
    };

    // A social message for the platform, falling back to the default list
    // and then to fixed copy, so sharing works even if the lines endpoint
    // could not be read.
    sharingText = (id) => {
        var lines = this.state.sharingLines;
        var text = 'Nice #opensource APIs for #devicedetection from ' +
            '@51Degrees. Just pick your properties and you’re good ' +
            'to go! %LINK%';
        if (lines) {
            var list = lines[id] && lines[id].length > 0
                ? lines[id]
                : lines['default'];
            if (list && list.length > 0) {
                text = list[Math.floor(Math.random() * list.length)];
            }
        }
        return text.replace(/%LINK%/g, this.state.sharingLink);
    };

    handleClick = (e) => {
        e.preventDefault();
        const { handleClick } = this.props;
        handleClick('');
    };

    copyCode = (e) => {
        e.preventDefault();
        this.copy(this.getCode());
        matomoTrackCustomEvent("ResourceKey Copied: ", this.getCode());
    };

    copy = (data) => {
        var dummy = document.createElement('textarea');
        document.body.appendChild(dummy);
        dummy.value = data;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);
        alert('Copied!');
    };

    getCode = () => {
        return this.props.resource.key;
    };

    scrollToTop = () => {
        if (this.refs.scroller) {
            this.refs.scroller.scrollTop = 0;
        }
    };

    render() {
        let classes = "g-panel g-panel--75";

        if (this.props.active) {
            classes += " is-active";
        }

        let referrer = () => {
            if (this.props.referer !== '') {
                return (
                    <p>Return to: <a href={this.props.referer} target="blank">{this.props.referer}</a></p>
                );
            }
        };

        // Sharing the configuration, which used to be its own step in the
        // flow before issue #71 made Implement the last one. The link
        // reloads the property selection, so it belongs beside the
        // Resource Key rather than on a step of its own.
        let share = () => {
            if (this.state.sharingState !== 'ready') {
                return (
                    <div className="c-share">
                        <h3 className="c-share__heading">
                            Share your configuration
                        </h3>
                        <p className="g-info__description">
                            Create a link that opens this collection of
                            properties, to share with colleagues or your
                            community. The link carries the properties
                            only, never your Resource Key, License Key or
                            contact details.
                        </p>
                        <button className="b-btn"
                            onClick={this.createSharingLink}
                            disabled={this.state.sharingState === 'loading'}>
                            {this.state.sharingState === 'loading'
                                ? 'Creating link…'
                                : 'Create a sharing link'}
                        </button>
                        {this.state.sharingState === 'failed' ? (
                            <p className="c-license-key__error" role="alert">
                                The sharing link could not be created. Try
                                again, or contact support@51degrees.com.
                            </p>
                        ) : null}
                    </div>
                );
            }

            var url = encodeURI(this.state.sharingLink);
            var title = encodeURI('Real-time data Superpowers');
            return (
                <div className="c-share">
                    <h3 className="c-share__heading">
                        Share your configuration
                    </h3>
                    <div className="b-form-group">
                        <div className="b-input-group">
                            <input type="text" className="b-input b-input--block"
                                value={this.state.sharingLink} readOnly
                                aria-label="Your shareable configuration link" />
                            <button className="b-btn"
                                onClick={this.copySharingLink}>
                                Copy&nbsp;link
                            </button>
                        </div>
                    </div>
                    <p className="g-info__description">Share via:</p>
                    <div className="g-footer__social-links b-mb-2">
                        <a className="c-option__vendor b-mb-2" target="blank"
                            rel="noopener noreferrer"
                            href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(this.sharingText('twitter'))}`}>
                            <img className="g-footer__social-icon"
                                src="/images/icon-twitter.svg" alt="Twitter" />
                        </a>
                        <a className="c-option__vendor b-mb-2" target="blank"
                            rel="noopener noreferrer"
                            href={`https://www.linkedin.com/shareArticle?mini=true&url=${url}`}>
                            <img className="g-footer__social-icon"
                                src="/images/icon-linkedin.svg" alt="LinkedIn" />
                        </a>
                        <a className="c-option__vendor b-mb-2" target="blank"
                            rel="noopener noreferrer"
                            href={`mailto:?subject=${title}&body=${encodeURIComponent(this.sharingText('email'))}`}>
                            <img className="g-footer__social-icon"
                                src="/images/icon-email.svg" alt="Email" />
                        </a>
                    </div>
                </div>
            );
        };

        return (
            <div className={classes}>
                <header className="c-category-header">
                    <a href="#" className="c-category-header__link is-reversable" onClick={this.handleClick}>Back</a> / Server side
                </header>

                <article className="g-info" ref="scroller">
                    <h2 className="g-info__title">Resource Key</h2>
                    <nav className="c-sub-nav">
                        <h3 className="c-sub-nav__heading">On this page</h3>
                        <p>This is your personal 51Degrees Cloud Resource Key, keep it somewhere safe. For additional cloud implementation examples see:</p>
                        <p>
                            Next time, an AI assistant can create a key
                            for you through our MCP server. See{' '}
                            <a href="https://51degrees.com/documentation/_services__configurator.html#Creating_a_Resource_Key_with_an_AI_agent"
                                target="_blank" rel="noopener noreferrer"
                                className="b-link">
                                the documentation
                            </a>.
                        </p>
                        <ul className="c-sub-nav__list">
                            <li className="c-sub-nav__link"><a href="https://docs.51degrees.com" className="c-sub-nav__item" target="blank">51Degrees V4 Documentation</a></li>
                            <li className="c-sub-nav__link"><a href="https://cloud.51degrees.com/api-docs/" className="c-sub-nav__item" target="blank">51Degrees Cloud Documentation</a></li>
                        </ul>
                    </nav>
                    <div className="c-code">
                        <header className="c-code__header" id="example1">
                            <h2 className="c-code__heading">Resource Key</h2>
                            <a href="#" className="c-copy-clipboard" onClick={this.copyCode}><img src="/images/icon-clipboard.svg" alt="Copy to clipboard" /></a>
                        </header>
                        <code className="c-code__block">
                            {this.getCode()}
                        </code>
                    </div>
                    <div className="g-info__description">
                        {referrer()}
                    </div>

                    {share()}
                    <a className="c-top-link hide" href="#" id="js-top" onClick={(e) => { e.preventDefault(); this.scrollToTop(); }}>
                        <img src="/images/back-to-top.svg" alt="Back to top" className="c-top-link__image" />
                        <span className="c-top-link__label">Back to top</span>
                    </a>
                </article>
            </div>);
    }
}
